import { render, staticRenderFns } from "./AdminBasic.vue?vue&type=template&id=af07f6e8&scoped=true"
import script from "./AdminBasic.vue?vue&type=script&lang=js"
export * from "./AdminBasic.vue?vue&type=script&lang=js"
import style0 from "./AdminBasic.vue?vue&type=style&index=0&id=af07f6e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af07f6e8",
  null
  
)

export default component.exports